import script from "./CatDefiner.vue?vue&type=script&setup=true&lang=js"
export * from "./CatDefiner.vue?vue&type=script&setup=true&lang=js"

import "./CatDefiner.vue?vue&type=style&index=0&id=e556e9b4&lang=sass"

const __exports__ = script;

export default __exports__